export default "__VITE_ASSET__BtDZi3MM__"